import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export interface MenuItem {
  label: string;
  icon: string;
  route?: string;
  externalUrl?: string;
  isSelected?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  

  getMenuItems(): MenuItem[] {
    return [
      { label: 'Início', icon: 'home', route: 'dashboard' },
      { label: 'Meus dados', icon: 'person', route: 'dashboard/meus-dados' },
      { label: 'Documentos', icon: 'description', route: 'dashboard/documentos' },
      { label: 'Ficha de inscrição', icon: 'assignment', route: 'dashboard/ficha-inscricao' },
      { label: 'Histórico', icon: 'history', route: 'dashboard/historico' },
      { label: 'Declaração de curso', icon: 'fact_check', route: 'dashboard/declaracao-curso' },
      { label: 'Certificados', icon: 'workspace_premium', route: 'dashboard/certificados' },
      { label: 'Identidade estudantil', icon: 'badge', route: 'dashboard/identidade-estudantil' },
      { label: 'Pagamentos', icon: 'payments', route: 'dashboard/pagamentos' },
      { label: 'Meu Curriculo', icon: 'article_person', route: 'dashboard/cadastro-curriculo' },
      { label: 'Banco de talentos', icon: 'work', route: 'dashboard/banco-talentos' },
      { label: 'Avaliação de cursos', icon: 'star_rate', route: 'dashboard/avaliacao-cursos' },
      { label: 'Moodle', icon: 'school', externalUrl: environment.urlMoodle }
    ];
  }
}
